import { AuthLayout } from '../components/AuthLayout/AuthLayout';
import { ForgotPasswordForm } from '../components/password/ForgotPasswordForm';

export const ForgotPasswordPage = () => {
  return (
    <AuthLayout>
      <ForgotPasswordForm />
    </AuthLayout>
  );
};
